"use strict";

module.exports = function (ngModule) {
  ngModule.constant("formlyVersion", VERSION);
};


/*****************
 ** WEBPACK FOOTER
 ** ./providers/formlyVersion.js
 ** module id = 12
 ** module chunks = 0
 **/